<!-- Notification Container with both Bell and Dropdown -->
<div class="relative">
  <!-- Notification Bell Component -->
  <app-notification-bell (toggleNotifications)="toggleNotifications()"></app-notification-bell>
  
  <!-- Notification Center Component -->
  <app-notification-center 
    [isOpen]="isOpen" 
    [visible]="isOpen"
  ></app-notification-center>
</div> 